import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';

// Diccionarios mínimos (ampliables)
const ES = {
  common: {
    editProfile: 'Editar perfil',
    signOut: 'Cerrar Sesión',
    language: 'Idioma',
    spanish: 'Español',
    english: 'Inglés',
    add: 'Añadir',
    min: 'min',
    total: 'total',
    day: 'día',
    days: 'días',
    save_changes: 'Guardar Cambios',
    save: 'Guardar',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    activate: 'Activar',
    deactivate: 'Desactivar',
    back: 'Volver',
  },
  appConfig: {
    title: 'Configuración de la Aplicación',
    subtitle: 'Personaliza el nombre, logo, colores y mensajes de tu aplicación',
    loading: 'Cargando configuración...',
    savedOk: 'Configuración guardada correctamente',
    savedError: 'Error guardando configuración',
    loadError: 'Error cargando configuración',
    tabs: {
      personalization: 'Personalización',
      reminders: 'Recordatorios',
      general: 'General'
    }
  },
  personalization: {
    appNameTitle: 'Nombre de la Aplicación',
    appNameHelp: 'Nombre que aparecerá en toda la aplicación',
    appNamePlaceholder: 'Ej: Mi Negocio',
    logoTitle: 'Logo de la Aplicación',
    logoUrlLabel: 'URL del logo (recomendado: 200x200px)',
    logoUrlPlaceholder: 'https://ejemplo.com/logo.png',
    upload: 'Subir',
    preview: 'Vista previa:',
    welcomeTitle: 'Mensaje de Bienvenida',
    welcomeEnabledLabel: 'Mostrar mensaje de bienvenida en la página principal',
    welcomeCustomLabel: 'Mensaje personalizado',
    welcomePlaceholder: '¡Bienvenidos! Reserva tu cita ahora...'
  },
  reminders: {
    generalSettings: 'Configuración General',
    enableAuto: 'Habilitar recordatorios automáticos',
    windowsTitle: 'Ventanas de Recordatorio',
    reminderWindow: 'Recordatorio',
    hoursBefore: 'Horas antes:',
    emailSubject: 'Asunto del email',
    emailContent: 'Contenido del email',
    subjectPlaceholder: 'Recordatorio: cita {fecha} a las {hora}',
    contentPlaceholder: 'Hola {nombre_cliente}, te recordamos tu cita...',
    availableVars: 'Variables disponibles:',
    sendTestTitle: 'Enviar email de prueba',
    testEmailPlaceholder: 'tu@email.com',
    sending: 'Enviando...',
    sendTest: 'Enviar prueba',
    testHelp: 'Se usa el texto configurado arriba (24h/2h). Solo para verificación.',
    saveConfig: 'Guardar Configuración',
    savedOk: 'Configuración guardada correctamente',
    savedError: 'Error guardando configuración',
    loadError: 'Error cargando configuración de recordatorios',
    noTenant: 'No se pudo identificar el negocio',
    invalidEmail: 'Introduce un email válido',
    testSent: 'Email de prueba enviado',
    testError: 'No se pudo enviar el email de prueba'
  },
  generalConfig: {
    myProfile: 'Mi perfil',
    name: 'Nombre',
    phone: 'Teléfono',
    saveProfile: 'Guardar perfil',
    businessSettings: 'Configuración del Negocio',
    requireApproval: 'Requerir aprobación del administrador para nuevos usuarios',
    maxPerUser: 'Máximo de citas por usuario',
    sliderHelp: 'Desliza para elegir entre 1 y 10.',
    bookingLink: 'Enlace de Reservas',
    bookingHelp: 'Comparte este enlace con tus clientes para que puedan reservar citas',
    copy: 'Copiar',
    showQr: 'Ver QR',
    hideQr: 'Ocultar QR',
    downloadPng: 'Descargar PNG',
    businessSlug: 'Slug del negocio',
    changeAdminPassword: 'Cambiar contraseña del administrador',
    passwordSendTo: 'Enviaremos un correo de restablecimiento a:',
    sending: 'Enviando...',
    sendResetLink: 'Enviar enlace de cambio',
    saveSettings: 'Guardar configuración',
    advanced: 'Avanzado',
    advancedHelp: 'Copias de seguridad, importación y reseteo.',
    exportData: 'Exportar Datos',
    importData: 'Importar Datos',
    resetting: 'Reseteando...',
    resetData: 'Resetear Datos',
    noAdminEmail: 'No se encontró el email del administrador',
    passwordEmailSent: 'Te hemos enviado un correo para cambiar la contraseña',
    passwordEmailError: 'No se pudo enviar el correo de cambio de contraseña',
    noCurrentUser: 'No se encontró el usuario actual',
    profileUpdated: 'Perfil actualizado',
    profileUpdateError: 'No se pudo actualizar el perfil'
  },
  accounting: {
    income: 'Ingresos',
    expenses: 'Gastos',
    net_profit: 'Beneficio',
    monthly_distribution: 'Distribución mensual (Ingresos vs Gastos)',
    monthly_evolution: 'Evolución Mensual',
    manage_description: 'Gestiona ingresos, gastos y reportes financieros',
    revenue_by_employee: 'Ingresos por trabajador (mensual)',
    income_eur: 'Ingresos (€)',
    transactions: 'Transacciones',
    no_transactions: 'No hay transacciones para mostrar',
    no_transactions_with_filters: 'No hay transacciones que coincidan con los filtros seleccionados'
  },
  services: {
    title: 'Gestión de Servicios',
    manage_description: 'Administra los servicios que ofreces a los clientes',
    configured: 'servicios configurados',
    add_service: 'Agregar Servicio',
    available: 'Servicios Disponibles',
    none: 'No hay servicios configurados',
    click_add: 'Haz clic en "Agregar Servicio" para crear los tuyos.',
    field_name: 'Nombre del Servicio',
    field_duration: 'Duración (minutos)',
    field_price: 'Precio (€)',
    field_description: 'Descripción'
  },
  subscription: {
    email_required: 'Email requerido para suscribirse',
    loading_prices: 'Cargando precios... inténtalo en 1-2 segundos',
    subscribe_error: 'Error al procesar la suscripción:',
    customer_not_found: 'No se encontró el cliente de Stripe',
    portal_error: 'No se pudo abrir el portal de facturación',
    premium_active: 'Premium Activo',
    renewal_in: 'Renovación en',
    subscription_active: 'Suscripción activa',
    trial_expired_title: 'Período de prueba finalizado',
    trial_expired_sub: 'Suscríbete para continuar usando todas las funciones',
    processing: 'Procesando...',
    subscribe_now: 'Suscribirme ahora',
    you_have_left: 'Te quedan',
    of_trial: 'de prueba',
    subscribe: 'Suscribirme',
    limited_offer: 'Oferta limitada',
    subscribe_with_discount: 'Suscribirme con descuento',
    offer_ended: 'Tu periodo de prueba y oferta han terminado.',
    subscribe_to_continue: 'Para seguir gestionando tus reservas, suscríbete.',
    unlock_all: 'Desbloquea todas las funciones',
    subscribe_premium: 'Suscríbete al plan Premium para acceder a todas las funciones',
    opening: 'Abriendo…',
    manage_subscription: 'Gestionar suscripción'
  },
  dashboardTexts: {
    dailySummaryTitle: 'Resumen diario',
    dailySummarySubtitle: 'Gestión de citas y actividades del día',
    today: 'Hoy',
    currentDay: 'Día actual',
    scheduledAppointments: 'Citas programadas',
    todaysAppointments: 'Citas de hoy',
    appointmentsOf: 'Citas del',
    appointments: 'citas',
    totalAppointments: 'Total Citas',
    completed: 'Completadas',
    pending: 'Pendientes',
    pendingUsers: 'Usuarios pendientes',
    pendingUsersApproval: 'Usuarios pendientes de aprobación',
    noPendingUsers: 'No hay usuarios pendientes.',
    dailyRevenue: 'Ingresos del día',
    previous: 'Anterior',
    next: 'Siguiente',
    tabletMode: 'Modo tablet',
    fullScreen: 'Pantalla completa',
    exitTabletMode: 'Salir modo tablet',
    exitFullScreen: 'Salir pantalla completa',
  },
  nav: {
    dashboard: 'Dashboard',
    appointments: 'Citas',
    accounting: 'Contabilidad',
    users: 'Usuarios',
    services: 'Servicios',
    employees: 'Empleados',
    cuadrante: 'Cuadrante',
    reports: 'Informes',
    dateControl: 'Control Fechas',
    config: 'Config',
    support: 'Soporte',
  },
  dateControl: {
    title: 'Control de Fechas Disponibles',
    subtitle: 'Controla qué fechas están abiertas para reservas. Por defecto, todas las fechas están cerradas.',
    replicatePatterns: 'Replicar Patrones',
    hideReplicator: 'Ocultar Replicador',
    weekOf: 'Semana del',
    to: 'al',
    goToThisWeek: 'Ir a esta semana',
    open: 'Abierta',
    closed: 'Cerrada',
    openSlots: 'slots abiertos',
    booked: 'reservados',
    openAction: 'Abrir',
    closeAction: 'Cerrar',
    systemInfo: 'Información del Sistema',
    howItWorks: 'Cómo funciona:',
    byDefault: 'Por defecto',
    byDefaultText: 'Todas las fechas están cerradas',
    toOpen: 'Para abrir',
    toOpenText: 'Haz clic en "Abrir" y selecciona los horarios',
    toClose: 'Para cerrar',
    toCloseText: 'Haz clic en "Cerrar" para bloquear reservas',
    toEdit: 'Para editar',
    toEditText: 'Haz clic en "Editar" para cambiar horarios',
    defaultsTitle: 'Horarios y capacidad por defecto:',
    range: 'Rango',
    interval: 'Intervalo',
    everyTen: 'Cada 10 minutos',
    capacityPerSlot: 'Capacidad por slot',
    capacityPerSlotText: 'igual al número de empleados activos (editable)',
    tipEdit: 'Puedes ajustar la capacidad y qué empleados pueden atender cada horario al pulsar “Editar”.',
    configureFor: 'Configurar horarios para',
    defaultClosed: 'Por defecto, todos los horarios están cerrados.',
    selectOnly: 'Selecciona SOLO los horarios que quieres abrir para reservas:',
    currentStatus: 'Estado actual:',
    noneSelected: 'Ningún horario seleccionado',
    slotsSelected: 'horarios seleccionados',
    perSlotSettings: 'Ajustes por horario',
    blockedEmployees: 'Empleados bloqueados:',
    blockedHint: '(Selecciona quiénes NO pueden atender este horario)',
    all: 'Todos',
    slots: 'slots'
  },
  reports: {
    title: 'Informes',
    subtitle: 'Genera y descarga todos los informes disponibles de tu negocio',
    hub: 'Centro de Informes',
    hub_desc: 'Desde aquí puedes acceder a todos los informes y exportaciones disponibles en tu sistema. Cada informe se genera con los datos más actualizados de tu negocio.',
    staff_schedule: 'Cuadrante de Personal',
    staff_schedule_desc: 'PDF del calendario de turnos y horarios de empleados',
    appointments_list: 'Listado de Citas',
    appointments_list_desc: 'CSV con todas las citas programadas y completadas',
    financial_report: 'Informe Financiero',
    financial_report_desc: 'PDF con ingresos, gastos y balance del negocio',
    config_backup: 'Backup de Configuración',
    config_backup_desc: 'JSON con todos los datos de configuración del negocio',
    general_monthly_report: 'Informe Mensual General',
    general_monthly_report_desc: 'PDF con resumen general y estadísticas del negocio',
    generate_pdf: 'Generar PDF',
    generate_csv: 'Generar CSV',
    generate_json: 'Generar JSON',
    quadrant_pdf_ok: 'PDF del cuadrante generado correctamente',
    quadrant_pdf_error: 'Error al generar el PDF del cuadrante',
    backup_ok: 'Backup de configuración generado correctamente',
    backup_error: 'Error al generar el backup de configuración',
    info: 'Información sobre los informes',
    all_include_datetime: 'Todos los informes incluyen la fecha y hora de generación',
    legend_pdf: 'Los PDFs se generan con formato A4 y están optimizados para impresión',
    legend_csv: 'Los archivos CSV pueden abrirse en Excel, Google Sheets o cualquier editor de texto',
    legend_json: 'Los backups JSON contienen todos los datos de configuración del negocio'
  },
  support: {
    login: 'Inicio de sesión',
    login_point1: 'Usa tu email y contraseña para acceder. Si olvidaste la contraseña, utiliza “¿Olvidaste tu contraseña?”',
    login_point2: 'Si ya estabas autenticado, la app te redirige automáticamente a tu panel',
    create_business: 'Crear negocio',
    create_business_point1: 'En la pestaña “Crear negocio” regístrate como administrador: nombre del negocio, email y contraseña',
    create_business_point2: 'Tras crear el negocio, se genera tu enlace único de reservas en /booking/{slug}',
    booking_link_qr: 'Enlace de reservas y QR',
    booking_link_qr_point1: 'En Configuración → General, copia el enlace de reservas y muéstralo con “Ver QR”',
    booking_link_qr_point2: 'Puedes descargar el QR en PNG para imprimir o compartir',
    email_reminders: 'Recordatorios por email (24h y 2h)',
    email_reminders_point1: 'Activa “Habilitar recordatorios automáticos” en Configuración → Recordatorios',
    email_reminders_point2: 'Personaliza asunto y contenido. Variables: {nombre_cliente}, {fecha}, {hora}, {servicio}, {negocio}',
    email_reminders_point3: 'Botón “Enviar email de prueba” para verificar el envío',
    users_employees: 'Usuarios y empleados',
    users_employees_point1: 'Administra usuarios y empleados desde su sección correspondiente',
    users_employees_point2: 'Puedes aprobar nuevos usuarios si tienes activada la aprobación manual',
    services_schedule: 'Servicios y agenda',
    services_schedule_point1: 'Configura servicios, precios y duración',
    services_schedule_point2: 'Gestiona citas desde el panel diario o semanal',
    subscriptions_payments: 'Suscripciones y pagos',
    subscriptions_payments_point1: 'La integración con Stripe permite gestionar planes y pagos',
    subscriptions_payments_point2: 'Ante dudas de cobros, contacta soporte desde este chat',
    support: 'Soporte',
    support_point1: 'Usa el chat de abajo para contactar con el equipo de soporte',
    support_point2: 'Describe el problema con detalle (pasos, hora aproximada, navegador/dispositivo) para acelerar la ayuda',
    getting_started: 'Guía de inicio',
    getting_started_desc: 'Repasa los 4 pasos para configurar tu negocio.',
    open_guide: 'Abrir guía',
    quick_guide: 'Guía rápida de la aplicación',
    search_help: 'Buscar ayuda...',
    no_results: 'No encontramos ayuda para esa búsqueda.',
    loading_chat: 'Cargando chat…',
    no_messages: 'No hay mensajes todavía.',
    you: 'Tú',
    agent: 'Soporte',
    write_message: 'Escribe tu mensaje',
    send: 'Enviar',
    contact_support: 'Contacta con soporte',
    contact_support_desc: 'Escríbenos y te ayudamos en lo que necesites. Si tienes alguna sugerencia para mejorar la app, también estaremos agradecidos de que la compartas con nosotros.',
    chat: 'Chat'
  },
  schedule: {
    title: 'Cuadrante de Personal',
    subtitle: 'Gestiona turnos, vacaciones y horarios del personal',
    employees: 'empleados',
    schedules_programmed: 'horarios programados',
    manage_shifts: 'Gestionar Turnos',
    print_pdf: 'Imprimir PDF',
    instructions: 'Instrucciones',
    instructions_text: 'Selecciona el tipo de turno que quieres asignar y luego haz clic en cualquier celda del calendario para asignar turnos a los empleados. Cada empleado aparece en una fila separada.',
    shift_type: 'Tipo de Turno',
    select_shift_type: 'Seleccionar tipo de turno',
    assigned_colors: 'Colores asignados',
    assigned_colors_subtitle: 'Leyenda de colores por tipo de turno',
    consumed_days: 'Contadores de días consumidos',
    morning: 'Mañana',
    afternoon: 'Tarde',
    night: 'Noche',
    vacation: 'Vacaciones',
    personal: 'Asuntos Propios',
    other: 'Otros',
    pdf_generated: 'PDF generado',
    edit_shift_type: 'Editar Tipo de Turno',
    add_shift_type: 'Añadir Nuevo Tipo de Turno',
    placeholder_shift_name: 'Ej: Turno de noche',
    vacation_days: 'Vacaciones (días/año)',
    personal_days: 'Asuntos Propios (días/año)',
    other_days: 'Otros (días/año)'
  },
  users: {
    manage_description: 'Administra la base de datos de usuarios registrados',
    client_link_title: 'Enlace para clientes',
    client_link_description: 'Comparte este enlace para que tus clientes se registren/inicien sesión y reserven en tu negocio.',
    link_copied: 'Enlace copiado al portapapeles',
    copy_link: 'Copiar enlace',
    download_png: 'Descargar PNG',
    generating_link: 'Generando enlace...',
    search_placeholder: 'Buscar por nombre, correo o teléfono...',
    pending_users_title: 'Usuarios pendientes de aprobación',
    total_users: 'Total Usuarios',
    approved_users: 'Usuarios Aprobados',
    with_phone: 'Con Teléfono',
    new_today: 'Nuevos Hoy',
    list_title: 'Lista de Usuarios',
    name: 'Usuario',
    email: 'Email',
    phone: 'Teléfono',
    actions: 'Acciones',
    click_row_for_actions: 'Pulsa una fila para ver acciones',
    no_users_found_search: 'No hay usuarios que coincidan con la búsqueda',
    no_registered_users: 'No hay usuarios registrados',
    banned: 'Baneado',
    active: 'Activo'
  },
  
  employees: {
    employee_name_placeholder: 'Nombre del empleado',
    active: 'Activo',
    inactive: 'Inactivo',
    name: 'Nombre',
    status: 'Estado',
    history: 'Historial',
    view_history: 'Ver historial'
  },
  appointments: {
    manage_description: 'Administra todas las citas del negocio',
    loading: 'Cargando citas...',
    found: 'citas encontradas'
  },
  booking: {
    book_appointment: 'Reservar Cita',
    confirm_booking: 'Confirmar Reserva',
    booking: 'Reservando...',
    select_service: 'Selecciona el tipo de servicio:',
  },
};

const EN = {
  common: {
    editProfile: 'Edit profile',
    signOut: 'Sign out',
    language: 'Language',
    spanish: 'Spanish',
    english: 'English',
    add: 'Add',
    min: 'min',
    total: 'total',
    day: 'day',
    days: 'days',
    save_changes: 'Save Changes',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    activate: 'Activate',
    deactivate: 'Deactivate',
    back: 'Back',
  },
  appConfig: {
    title: 'Application Settings',
    subtitle: 'Customize the app name, logo, colors and messages',
    loading: 'Loading settings...',
    savedOk: 'Settings saved successfully',
    savedError: 'Error saving settings',
    loadError: 'Error loading settings',
    tabs: {
      personalization: 'Personalization',
      reminders: 'Reminders',
      general: 'General'
    }
  },
  personalization: {
    appNameTitle: 'Application Name',
    appNameHelp: 'Name that will appear across the app',
    appNamePlaceholder: 'e.g. My Business',
    logoTitle: 'Application Logo',
    logoUrlLabel: 'Logo URL (recommended: 200x200px)',
    logoUrlPlaceholder: 'https://example.com/logo.png',
    upload: 'Upload',
    preview: 'Preview:',
    welcomeTitle: 'Welcome Message',
    welcomeEnabledLabel: 'Show welcome message on the home page',
    welcomeCustomLabel: 'Custom message',
    welcomePlaceholder: 'Welcome! Book your appointment now...'
  },
  reminders: {
    generalSettings: 'General Settings',
    enableAuto: 'Enable automatic reminders',
    windowsTitle: 'Reminder Windows',
    reminderWindow: 'Reminder',
    hoursBefore: 'Hours before:',
    emailSubject: 'Email subject',
    emailContent: 'Email content',
    subjectPlaceholder: 'Reminder: appointment {fecha} at {hora}',
    contentPlaceholder: 'Hi {nombre_cliente}, this is a reminder for your appointment...',
    availableVars: 'Available variables:',
    sendTestTitle: 'Send test email',
    testEmailPlaceholder: 'your@email.com',
    sending: 'Sending...',
    sendTest: 'Send test',
    testHelp: 'Uses the text configured above (24h/2h). For verification only.',
    saveConfig: 'Save Settings',
    savedOk: 'Settings saved successfully',
    savedError: 'Error saving settings',
    loadError: 'Error loading reminder settings',
    noTenant: 'Could not identify business',
    invalidEmail: 'Enter a valid email',
    testSent: 'Test email sent',
    testError: 'Could not send test email'
  },
  generalConfig: {
    myProfile: 'My profile',
    name: 'Name',
    phone: 'Phone',
    saveProfile: 'Save profile',
    businessSettings: 'Business Settings',
    requireApproval: 'Require admin approval for new users',
    maxPerUser: 'Max appointments per user',
    sliderHelp: 'Slide to choose between 1 and 10.',
    bookingLink: 'Booking Link',
    bookingHelp: 'Share this link with your clients so they can book',
    copy: 'Copy',
    showQr: 'Show QR',
    hideQr: 'Hide QR',
    downloadPng: 'Download PNG',
    businessSlug: 'Business slug',
    changeAdminPassword: 'Change admin password',
    passwordSendTo: 'We will send a reset email to:',
    sending: 'Sending...',
    sendResetLink: 'Send reset link',
    saveSettings: 'Save settings',
    advanced: 'Advanced',
    advancedHelp: 'Backups, import and reset.',
    exportData: 'Export Data',
    importData: 'Import Data',
    resetting: 'Resetting...',
    resetData: 'Reset Data',
    noAdminEmail: 'Admin email not found',
    passwordEmailSent: 'We sent you an email to change the password',
    passwordEmailError: 'Could not send password change email',
    noCurrentUser: 'Current user not found',
    profileUpdated: 'Profile updated',
    profileUpdateError: 'Could not update profile'
  },
  accounting: {
    income: 'Income',
    expenses: 'Expenses',
    net_profit: 'Net profit',
    monthly_distribution: 'Monthly distribution (Income vs Expenses)',
    monthly_evolution: 'Monthly Evolution',
    manage_description: 'Manage income, expenses and financial reports',
    revenue_by_employee: 'Revenue by employee (monthly)',
    income_eur: 'Income (€)',
    transactions: 'Transactions',
    no_transactions: 'No transactions to display',
    no_transactions_with_filters: 'No transactions match the selected filters'
  },
  services: {
    title: 'Services Management',
    manage_description: 'Manage the services you offer to clients',
    configured: 'services configured',
    add_service: 'Add Service',
    available: 'Available Services',
    none: 'No services configured',
    click_add: 'Click on "Add Service" to create yours.',
    field_name: 'Service Name',
    field_duration: 'Duration (minutes)',
    field_price: 'Price (€)',
    field_description: 'Description'
  },
  employees: {
    employee_name_placeholder: 'Employee name',
    active: 'Active',
    inactive: 'Inactive',
    name: 'Name',
    status: 'Status',
    history: 'History',
    view_history: 'View history'
  },
  subscription: {
    email_required: 'Email required to subscribe',
    loading_prices: 'Loading prices... try again in a second',
    subscribe_error: 'Subscription error:',
    customer_not_found: 'Stripe customer not found',
    portal_error: 'Could not open billing portal',
    premium_active: 'Premium Active',
    renewal_in: 'Renewal in',
    subscription_active: 'Subscription active',
    trial_expired_title: 'Trial period has ended',
    trial_expired_sub: 'Subscribe to continue using all features',
    processing: 'Processing...',
    subscribe_now: 'Subscribe now',
    you_have_left: 'You have',
    of_trial: 'of trial left',
    subscribe: 'Subscribe',
    limited_offer: 'Limited offer',
    subscribe_with_discount: 'Subscribe with discount',
    offer_ended: 'Your trial and offer have ended.',
    subscribe_to_continue: 'To continue managing your bookings, please subscribe.',
    unlock_all: 'Unlock all features',
    subscribe_premium: 'Subscribe to Premium to access all features',
    opening: 'Opening…',
    manage_subscription: 'Manage subscription'
  },
  users: {
    manage_description: 'Manage the database of registered users',
    client_link_title: 'Link for clients',
    client_link_description: 'Share this link so your clients can register/log in and book.',
    link_copied: 'Link copied to clipboard',
    copy_link: 'Copy link',
    download_png: 'Download PNG',
    generating_link: 'Generating link...',
    search_placeholder: 'Search by name, email or phone...',
    total_users: 'Total Users',
    approved_users: 'Approved Users',
    with_phone: 'With phone',
    new_today: 'New today',
    pending_users_title: 'Users pending approval',
    approve: 'Approve',
    delete: 'Delete',
    list_title: 'Users List',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    actions: 'Actions',
    history: 'History',
    edit: 'Edit',
    ban: 'Ban',
    unban: 'Unban',
  },
  users_es: {},
  dashboardTexts: {
    dailySummaryTitle: 'Daily summary',
    dailySummarySubtitle: 'Manage appointments and daily activity',
    today: 'Today',
    currentDay: 'Current day',
    scheduledAppointments: 'Scheduled appointments',
    todaysAppointments: "Today's appointments",
    appointmentsOf: 'Appointments of',
    appointments: 'appointments',
    totalAppointments: 'Total Appointments',
    completed: 'Completed',
    pending: 'Pending',
    pendingUsers: 'Pending users',
    pendingUsersApproval: 'Pending users for approval',
    noPendingUsers: 'No pending users.',
    dailyRevenue: 'Daily revenue',
    previous: 'Previous',
    next: 'Next',
    tabletMode: 'Tablet mode',
    fullScreen: 'Full screen',
    exitTabletMode: 'Exit tablet mode',
    exitFullScreen: 'Exit full screen',
  },
  nav: {
    dashboard: 'Dashboard',
    appointments: 'Appointments',
    accounting: 'Accounting',
    users: 'Users',
    services: 'Services',
    employees: 'Employees',
    cuadrante: 'Schedule',
    reports: 'Reports',
    dateControl: 'Date Control',
    config: 'Settings',
    support: 'Support',
  },
  dateControl: {
    title: 'Available Dates Control',
    subtitle: 'Control which dates are open for bookings. By default, all dates are closed.',
    replicatePatterns: 'Replicate Patterns',
    hideReplicator: 'Hide Replicator',
    weekOf: 'Week from',
    to: 'to',
    goToThisWeek: 'Go to this week',
    open: 'Open',
    closed: 'Closed',
    openSlots: 'open slots',
    booked: 'booked',
    openAction: 'Open',
    closeAction: 'Close',
    systemInfo: 'System Information',
    howItWorks: 'How it works:',
    byDefault: 'By default',
    byDefaultText: 'All dates are closed',
    toOpen: 'To open',
    toOpenText: 'Click "Open" and select the times',
    toClose: 'To close',
    toCloseText: 'Click "Close" to block bookings',
    toEdit: 'To edit',
    toEditText: 'Click "Edit" to change times',
    defaultsTitle: 'Default times and capacity:',
    range: 'Range',
    interval: 'Interval',
    everyTen: 'Every 10 minutes',
    capacityPerSlot: 'Capacity per slot',
    capacityPerSlotText: 'equal to the number of active employees (editable)',
    tipEdit: 'You can adjust capacity and which employees can serve each time by clicking “Edit”.',
    configureFor: 'Configure times for',
    defaultClosed: 'By default, all times are closed.',
    selectOnly: 'Select ONLY the times you want to open for bookings:',
    currentStatus: 'Current status:',
    noneSelected: 'No time selected',
    slotsSelected: 'times selected',
    perSlotSettings: 'Per-slot settings',
    blockedEmployees: 'Blocked employees:',
    blockedHint: '(Select who CANNOT serve this time)',
    all: 'All',
    slots: 'slots'
  },
  reports: {
    title: 'Reports',
    subtitle: 'Generate and download all business reports',
    hub: 'Reports Hub',
    hub_desc: 'Access every report and export available. Each report uses the latest business data.',
    staff_schedule: 'Staff Schedule',
    staff_schedule_desc: 'PDF calendar of staff shifts and hours',
    appointments_list: 'Appointments List',
    appointments_list_desc: 'CSV with all scheduled and completed appointments',
    financial_report: 'Financial Report',
    financial_report_desc: 'PDF with income, expenses and business balance',
    config_backup: 'Configuration Backup',
    config_backup_desc: 'JSON with all business configuration data',
    general_monthly_report: 'General Monthly Report',
    general_monthly_report_desc: 'PDF with overall summary and statistics',
    generate_pdf: 'Generate PDF',
    generate_csv: 'Generate CSV',
    generate_json: 'Generate JSON',
    quadrant_pdf_ok: 'Quadrant PDF generated successfully',
    quadrant_pdf_error: 'Error generating quadrant PDF',
    backup_ok: 'Configuration backup generated successfully',
    backup_error: 'Error generating configuration backup',
    info: 'Report information',
    all_include_datetime: 'All reports include generation date and time',
    legend_pdf: 'PDFs are generated in A4 optimized for printing',
    legend_csv: 'CSV files can be opened in Excel, Google Sheets or any text editor',
    legend_json: 'JSON backups include all business configuration data'
  },
  support: {
    login: 'Log in',
    login_point1: 'Use your email and password. If you forgot it, use “Forgot your password?”',
    login_point2: 'If you were already authenticated, the app redirects you to your dashboard',
    create_business: 'Create business',
    create_business_point1: 'In “Create business” sign up as admin: business name, email and password',
    create_business_point2: 'After creating it, your unique booking link is /booking/{slug}',
    booking_link_qr: 'Booking link & QR',
    booking_link_qr_point1: 'Settings → General: copy the booking link and show “View QR”',
    booking_link_qr_point2: 'You can download the QR as PNG to print or share',
    email_reminders: 'Email reminders (24h and 2h)',
    email_reminders_point1: 'Enable “Automatic reminders” in Settings → Reminders',
    email_reminders_point2: 'Customize subject and content. Variables: {nombre_cliente}, {fecha}, {hora}, {servicio}, {negocio}',
    email_reminders_point3: 'Use “Send test email” to verify',
    users_employees: 'Users and employees',
    users_employees_point1: 'Manage users and employees from their sections',
    users_employees_point2: 'Approve new users if manual approval is enabled',
    services_schedule: 'Services and schedule',
    services_schedule_point1: 'Configure services, prices and duration',
    services_schedule_point2: 'Manage appointments from the daily or weekly view',
    subscriptions_payments: 'Subscriptions and payments',
    subscriptions_payments_point1: 'Stripe integration manages plans and payments',
    subscriptions_payments_point2: 'If in doubt about charges, contact support in this chat',
    support: 'Support',
    support_point1: 'Use the chat below to contact the support team',
    support_point2: 'Describe the problem in detail (steps, approximate time, browser/device)',
    getting_started: 'Getting started',
    getting_started_desc: 'Review the 4 steps to set up your business.',
    open_guide: 'Open guide',
    quick_guide: 'App quick guide',
    search_help: 'Search help...',
    no_results: 'No help found for that search.',
    loading_chat: 'Loading chat…',
    no_messages: 'No messages yet.',
    you: 'You',
    agent: 'Support',
    write_message: 'Write your message',
    send: 'Send',
    contact_support: 'Contact support',
    contact_support_desc: 'Write to us and we will help you. If you have any suggestions to improve the app, we’d be grateful if you share them with us.',
    chat: 'Chat'
  },
  schedule: {
    title: 'Staff Schedule',
    subtitle: 'Manage shifts, vacations and staff hours',
    employees: 'employees',
    schedules_programmed: 'scheduled shifts',
    manage_shifts: 'Manage Shifts',
    print_pdf: 'Print PDF',
    instructions: 'Instructions',
    instructions_text: 'Select the shift type you want to assign and then click any calendar cell to assign shifts to employees. Each employee appears on a separate row.',
    shift_type: 'Shift Type',
    select_shift_type: 'Select shift type',
    assigned_colors: 'Assigned colors',
    assigned_colors_subtitle: 'Color legend by shift type',
    consumed_days: 'Consumed days counters',
    morning: 'Morning',
    afternoon: 'Afternoon',
    night: 'Night',
    vacation: 'Vacation',
    personal: 'Personal matters',
    other: 'Other',
    pdf_generated: 'PDF generated',
    edit_shift_type: 'Edit Shift Type',
    add_shift_type: 'Add New Shift Type',
    placeholder_shift_name: 'e.g. Night shift',
    vacation_days: 'Vacation (days/year)',
    personal_days: 'Personal (days/year)',
    other_days: 'Other (days/year)'
  },
  appointments: {
    manage_description: 'Manage all business appointments',
    loading: 'Loading appointments...',
    found: 'appointments found'
  },
};

const DICTS = { es: ES, en: EN };
const DEFAULT_LANG = 'es';

const LangContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  t: (key) => key,
});

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(DEFAULT_LANG);

  useEffect(() => {
    try {
      const saved = localStorage.getItem('app_lang');
      if (saved && (saved === 'es' || saved === 'en')) {
        setLangState(saved);
        return;
      }
      // Detección simple por navegador
      const nav = (navigator.language || 'es').slice(0, 2).toLowerCase();
      setLangState(nav === 'en' ? 'en' : 'es');
    } catch {
      setLangState('es');
    }
  }, []);

  const setLang = (l) => {
    const next = (l === 'en' ? 'en' : 'es');
    setLangState(next);
    try { localStorage.setItem('app_lang', next); } catch {}
    try { document.documentElement.setAttribute('lang', next); } catch {}
  };

  const t = useMemo(() => {
    return (key, _ns = 'common') => {
      try {
        const dict = DICTS[lang] || DICTS.es;
        const parts = key.split('.');
        let cur = dict;
        for (const p of parts) {
          cur = cur?.[p];
          if (cur === undefined) break;
        }
        return (typeof cur === 'string' ? cur : key);
      } catch { return key; }
    };
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);


